import { render, staticRenderFns } from "./DepartmentCreateDialog.vue?vue&type=template&id=6037d35a&scoped=true"
import script from "./DepartmentCreateDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DepartmentCreateDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DepartmentCreateDialog.vue?vue&type=style&index=0&id=6037d35a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6037d35a",
  null
  
)

export default component.exports